import React from 'react';
import I18n from 'i18n-js';
import { string } from 'prop-types';
import cwoModuleConfig from '../helpers/cwoModuleConfig';

const CwoModuleLabel = ({ cwoModule = '' }) => (
  <span className="tickets-index-page__cwo-select-label">
    <span className="tickets-index-page__cwo-select-label__icon">
      {cwoModuleConfig[cwoModule]?.icon}
    </span>
    {I18n.t(`tickets.cwo_modules.${cwoModule}`)}
  </span>
);

CwoModuleLabel.propTypes = {
  cwoModule: string,
};

export default CwoModuleLabel;
